import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
// import { DateInputComponent } from './date-input.component';

@Component({
  selector: 'wl-date-input',
  templateUrl: './date-input.component.html',
  styles: [],
  providers: [DatePipe]
})
export class DateInputComponent implements OnInit {
  startDate: string;
  endDate: string;
  @Output() dateRangeSelected = new EventEmitter<any>()
  maxDate:any;
  getMonth: any;
  getYear: number;
  getDate: any;
  maxMonth: string;
  event$: any;
  currUrl: string;
  constructor( private snackbar: MatSnackBar,  private router: Router,private datePipe: DatePipe) {
    this.event$ = 
    this.router.events
    .subscribe(
      (event) => {
        if(event instanceof NavigationEnd) {
          this.currUrl = this.router.url;
          console.log('printevent', this.currUrl);
          if(this.currUrl == '/fresh-app/view-summary'){
           console.log('our website');
           const today = new Date();
           const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);    
           this.startDate = this.datePipe.transform(startOfMonth, 'yyyy-MM-dd');
           this.endDate = this.datePipe.transform(today, 'yyyy-MM-dd');
           }
        }
      });
   }

  ngOnInit() {    
    var todayDate = new Date();
    this.getDate = todayDate.getDate();
    this.getMonth = todayDate.getMonth() + 1
    console.log('month', this.getMonth);
    this.getYear = todayDate.getUTCFullYear();
    if(this.getMonth <10){
      this.getMonth = '0' + this.getMonth;
      console.log('add 0', this.getMonth);
    }
    if(this.getDate <10){
      this.getDate = '0' + this.getDate;
      console.log('add 0', this.getDate);
    }
   this.maxDate = this.getYear + "-" + this.getMonth + "-" + this.getDate;  
  }
  // onStartDateChange() {
  //   this.dateRangeSelected.emit({ startDate: this.startDate });
  // }

  // onEndDateChange() {
  //   this.dateRangeSelected.emit({ endDate: this.endDate });
  // }
  // ngAfterViewInit() {
  //   // Code to open the calendar
  //   const calendarInput = document.getElementById('calendar') as HTMLInputElement;
  //   calendarInput.click();
  // }

  submit() {
    if(this.startDate <= this.maxDate && this.startDate >= '2022-01-01' && this.endDate <= this.maxDate && this.endDate >= '2022-01-01'){
    this.dateRangeSelected.emit({ startDate: this.startDate, endDate: this.endDate });
    }else{
      this.snackbar.open("Please enter the valid date",'OK', {duration:4000})
    }
  }
}
